<div class="progressContainer" *ngIf="progressBar()">
  <p-progressSpinner *ngIf="progressBar()"></p-progressSpinner>
</div>
<div class="layout-container" [ngClass]="containerClass">
  <kanzi-ui-top-bar
    [warehouseRootList]="warehouseRootList() || null"
    [warehouseRootSelected]="userWarehouseRootSelected()"
    [dataloaderHide]="dataloaderHide()"
    (selectWarehouseRoot)="onSelectWarehouse($event)"
    (selectLanguage)="changeLanguage($event)"
  ></kanzi-ui-top-bar>
  <kanzi-ui-main-sidebar
    [mainMenuItems]="itemsMenu()"
    [userProfile]="userProfile()"
    [userConfigsWMS]="userConfigs()"
    (onLogout)="logoutSession()"
  ></kanzi-ui-main-sidebar>
  <div class="layout-content-wrapper">
    <kanzi-ui-breadcrumb id="breadcrumbStep"></kanzi-ui-breadcrumb>
    <div class="layout-content" id="contentStep">
      <router-outlet></router-outlet>
    </div>
    <kanzi-ui-footer [versionName]="kanziAppVersion()"></kanzi-ui-footer>
  </div>
</div>
<kanzi-apes-alert-voice />
<kanzi-apes-alert />
